import cn from "classnames";
import type { ChangeEvent } from "react";
import styles from "./RangeInput.module.css";

interface RangeInputProps {
    min: number;
    max: number;
    step: number;
    value: number;
    name: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    className?: string;
}

export function RangeInput({ min, max, step, value, name, onChange, className }: RangeInputProps) {
    const rangeStyles = cn(styles.range, className);

    return (
        <input
            className={rangeStyles}
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            name={name}
            onChange={onChange}
        />
    );
}
